"use client";

import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";
import Image from "next/image";
import Link from "next/link";

export function HeroSection() {
  const { isAuthenticated, login } = useAuth();

  return (
    <section className="relative w-full min-h-screen overflow-hidden">
      {/* Mobile Background */}
      <Image
        src="https://pulsarmoney.b-cdn.net/quests/campaigns/yield/hero-mobile.png"
        alt="Yiedl Portal"
        fill
        priority
        className="md:hidden object-cover object-top"
        quality={100}
      />
      {/* Desktop Background */}
      <Image
        src="https://pulsarmoney.b-cdn.net/quests/campaigns/yield/hero-desktop.png"
        alt="Yiedl Portal"
        fill
        priority
        className="hidden md:block object-cover"
        quality={100}
      />

      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-6 text-center">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-4 md:mb-6 leading-tight">
          Yiedl Portal
        </h1>

        <p className="text-lg md:text-xl text-white/90 mb-2 max-w-2xl">
          1,000+ minds. 1 battlefield.
        </p>

        <p className="text-lg md:text-xl text-white/90 mb-8 md:mb-10 max-w-2xl">
          Only the strongest AIs survive — to serve your capital.
        </p>

        {isAuthenticated ? (
          <Link href="/quests">
            <Button
              className="bg-yiedl-primary hover:bg-yiedl-primary/90 text-black px-8 md:px-10 py-3 md:py-4 rounded-xl text-base md:text-lg font-semibold transition-all duration-200 ease-out"
            >
              View Quests
            </Button>
          </Link>
        ) : (
          <Button
            onClick={login}
            className="bg-yiedl-primary hover:bg-yiedl-primary/90 text-black px-8 md:px-10 py-3 md:py-4 rounded-xl text-base md:text-lg font-semibold transition-all duration-200 ease-out"
          >
            Log In
          </Button>
        )}
      </div>
    </section>
  );
}
